"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Android_1 = __importDefault(require("../Icons/Android"));
var Apple_1 = __importDefault(require("../Icons/Apple"));
var config = {
    columns: [
        {
            items: [
                {
                    linkProps: {
                        href: '//www.veepee.it/Vp4/Help/question.ashx?cypher=30khVhDNSC4UVOKbWgPTMg%3D%3D'
                    },
                    text: 'Chi siamo'
                },
                {
                    linkProps: {
                        href: '//www.veepee.it/Vp4/Help/Default.aspx'
                    },
                    text: 'Contattaci'
                },
                {
                    linkProps: {
                        href: '//www.veepee.it/Vp4/Help/question.ashx?cypher=R8lMNFOtKWBwiuRfFG8CcQ%3D%3D'
                    },
                    text: 'Sicurezza'
                },
                {
                    linkProps: {
                        href: '//www.veepee.it/vp4/Help/Answer.aspx?cypher=pDJ6X1GE%2Bh5PGl11d%2B3Po4svjVqF%2B0vjGkHXama7LF973vg8VKAwY%2BYuN4PEynM0t9PHZAi6UFbXlqV14vJKqcVUZBchJXzKRVuSR7RzJpVliOE9vXJNmMsjcZaY%2BwufNJXodK3qUjRUIGk8mmv8BbZe1kYH27rdFAjjACIcroYR6xwdb%2B7tgE3PuIpgP4V6%2BuuBCxEKW4UD%2BEMtrT5VSmVv6pvQN5ibMSMVkzA%2BjyY%3D'
                    },
                    text: 'Note Legali'
                }
            ],
            title: 'Assistenza & contatti'
        },
        {
            items: [
                {
                    linkProps: {
                        href: '//www.veepee.it/cgv/it-IT/Condizioni_Generali_di_Vendita.pdf',
                        target: '_blank'
                    },
                    text: 'Termini e condizioni d\'uso del sito Viaggi'
                },
                {
                    linkProps: {
                        href: '//www.veepee.it/ns/it-it/legal/privacy'
                    },
                    text: 'Protezione dei miei dati personali'
                },
                {
                    linkProps: {
                        href: '//www.veepee.it/vp4/Help/Answer.aspx?cypher=Q%2BJ3sfc3KCAKh15QeGPWCA%3D%3D'
                    },
                    text: 'Mediazione'
                }
            ],
            title: 'Condizioni Generali'
        },
        {
            items: [
                {
                    linkProps: {
                        href: '//careers.veepee.com/vptech-2/',
                        target: '_blank'
                    },
                    text: 'vpTech'
                },
                {
                    linkProps: {
                        href: '//careers.veepee.com/en/home-page-en',
                        target: '_blank'
                    },
                    text: 'Veepee'
                }
            ],
            title: 'Join us'
        },
        {
            items: [],
            title: ''
        }
    ],
    country: 'IT',
    flag: 'IT',
    header: {
        apps: {
            items: [
                {
                    icon: Apple_1.default,
                    label: 'iOS',
                    linkProps: {
                        href: '//apps.apple.com/it/app/veepee-by-vente-privee/id906681058',
                        target: '_blank'
                    }
                },
                {
                    icon: Android_1.default,
                    label: 'Android',
                    linkProps: {
                        href: '//play.google.com/store/apps/details?id=com.venteprivee',
                        target: '_blank'
                    }
                }
            ],
            title: 'Le nostri applicazioni'
        },
        social: []
    },
    lang: 'it',
    logoSubtitle: 'VP, grandi marchi a prezzi scontati'
};
exports.default = config;
